// extracted by mini-css-extract-plugin
export var billingAddress = "_re-f";
export var contactInfo = "_re-c";
export var customerInfoContainer = "_re-b";
export var customerInfoRow = "_re-9";
export var customerInfoSection = "_re-a";
export var fullWidthDividerMobile = "_re-g";
export var imageContainer = "_re-1";
export var paymentMethod = "_re-d";
export var priceText = "_re-6";
export var priceTextMobile = "_re-7";
export var product = "_re-0";
export var productImage = "_re-2";
export var productInfo = "_re-4";
export var productTitle = "_re-8";
export var quantityBadge = "_re-3";
export var quantityText = "_re-5";
export var shippingAddress = "_re-e";